import { render, staticRenderFns } from "./PvpStatusText.vue?vue&type=template&id=53baf468&scoped=true"
import script from "./PvpStatusText.vue?vue&type=script&lang=js"
export * from "./PvpStatusText.vue?vue&type=script&lang=js"
import style0 from "./PvpStatusText.vue?vue&type=style&index=0&id=53baf468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53baf468",
  null
  
)

export default component.exports